import { render, staticRenderFns } from "./CatalogPreview.vue?vue&type=template&id=ecd22408"
import script from "./CatalogPreview.vue?vue&type=script&lang=js"
export * from "./CatalogPreview.vue?vue&type=script&lang=js"
import style0 from "./CatalogPreview.vue?vue&type=style&index=0&id=ecd22408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports